import { useState } from "react";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/motion";
import { api, formatApiErrorDetail } from "../lib/api";
import { toast } from "sonner";
import { IMAGES } from "../data/site";
import { Loader2, Sparkles } from "lucide-react";

const INTERESTS = ["Hill Stations", "Backwaters", "Wildlife", "Beaches", "Waterfalls", "Ayurveda", "Culture & Heritage", "Adventure"];

export default function CustomPackage() {
  const [loading, setLoading] = useState(false);
  const [picked, setPicked] = useState([]);
  const [form, setForm] = useState({ name: "", email: "", phone: "", travelers: "", travel_date: "", message: "" });
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const toggle = (i) => setPicked((p) => (p.includes(i) ? p.filter((x) => x !== i) : [...p, i]));

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/enquiries", { ...form, travel_type: "Custom", package: "Custom Package", message: `Interests: ${picked.join(", ")}. ${form.message}` });
      toast.success("Thank you! We'll design your custom Kerala itinerary and reach out shortly.");
      setForm({ name: "", email: "", phone: "", travelers: "", travel_date: "", message: "" });
      setPicked([]);
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };
  const field = "w-full bg-transparent border-0 border-b border-ink/20 px-0 py-3 text-ink placeholder:text-ink/40 focus:outline-none focus:border-emerald";

  return (
    <div data-testid="custom-package-page">
      <PageHero eyebrow="Custom Package" title={["Design your own", "Kerala story."]}
        subtitle="Tell us what moves you and we'll build a bespoke itinerary — your dates, your pace, your budget." image={IMAGES.athirappillyAerial} />
      <section className="max-w-[900px] mx-auto px-5 lg:px-10 py-24">
        <Reveal>
          <form onSubmit={submit} className="space-y-10" data-testid="custom-form">
            <div>
              <p className="eyebrow text-gold mb-5 flex items-center gap-2"><Sparkles className="w-4 h-4" /> What interests you?</p>
              <div className="flex flex-wrap gap-3">
                {INTERESTS.map((it) => (
                  <button type="button" key={it} onClick={() => toggle(it)} data-testid={`interest-${it.toLowerCase().replace(/\s+/g, "-").replace(/&/g,"and")}`}
                    className={`px-5 py-2.5 text-sm border rounded-full transition-colors ${picked.includes(it) ? "bg-emerald text-cream border-emerald" : "border-emerald/20 text-ink/70 hover:border-emerald"}`}>{it}</button>
                ))}
              </div>
            </div>
            <div className="grid sm:grid-cols-2 gap-6">
              <input required placeholder="Full name" value={form.name} onChange={set("name")} className={field} data-testid="custom-name" />
              <input required type="email" placeholder="Email" value={form.email} onChange={set("email")} className={field} data-testid="custom-email" />
              <input required placeholder="Phone / WhatsApp" value={form.phone} onChange={set("phone")} className={field} data-testid="custom-phone" />
              <input placeholder="Travellers (e.g. 2 adults, 1 child)" value={form.travelers} onChange={set("travelers")} className={field} data-testid="custom-travelers" />
              <input placeholder="Preferred travel dates" value={form.travel_date} onChange={set("travel_date")} className={field + " sm:col-span-2"} data-testid="custom-date" />
            </div>
            <textarea placeholder="Anything else? Budget, occasion, must-sees..." value={form.message} onChange={set("message")} className={field + " min-h-[100px]"} data-testid="custom-message" />
            <button type="submit" disabled={loading} className="bg-emerald text-cream px-10 py-4 text-xs uppercase tracking-[0.2em] font-semibold hover:bg-gold transition-colors flex items-center gap-2" data-testid="custom-submit">
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Sparkles className="w-4 h-4" />} {loading ? "Sending..." : "Request My Custom Itinerary"}
            </button>
          </form>
        </Reveal>
      </section>
    </div>
  );
}
